import { arrayOf, objectOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

import {
  isCreativeVariantAction,
  isCreativeVariantWarning,
} from "../decisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariants";
import type {
  DeleteDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantIdResult,
  PutDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantIdResult,
} from "./types";

export const isPutDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantIdResult =
  objectOf<PutDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantIdResult>({
    variant: (
      v: unknown
    ): v is PutDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantIdResult["variant"] => {
      if (!isCreativeVariantAction(v)) {
        return false;
      }
      const replacementVariantId = (v as { replacementVariantId?: unknown }).replacementVariantId;
      return replacementVariantId === undefined || typeof replacementVariantId === "number";
    },
    warnings: arrayOf(isCreativeVariantWarning),
  });

export const isDeleteDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantIdResult =
  objectOf<DeleteDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantIdResult>({
    deletedVariantId: number,
  });
